const iconConfig = [{
	name: 'iconNext',
	inputType: 'icon',
	label: 'Choose next icon',
	default: false
}, {
	name: 'iconNextSize',
	inputType: 'text',
	label: 'Set size on next icon',
	default: '2em'
}, {
	name: 'iconNextColor',
	inputType: 'color',
	label: 'Set color on next icon',
	default: '#000'
}, {
	name: 'iconPrev',
	inputType: 'icon',
	label: 'Choose previous icon',
	default: false
}, {
	name: 'iconPrevSize',
	inputType: 'text',
	label: 'Set size on previous icon',
	default: '2em'
}, {
	name: 'iconPrevColor',
	inputType: 'color',
	label: 'Set color on previous icon',
	default: '#000'
}];

const imageConfig = [{
	name: 'imageNext',
	inputType: 'media',
	label: 'Choose next image',
	default: ''
}, {
	name: 'imagePrev',
	inputType: 'media',
	label: 'Choose previous image',
	default: ''
}];

const conditionallyAddConfig = (node, conditionStr, configArray) => (node && node.props.sliderArrowsType === conditionStr) ? configArray : [];

export default node => ({
	type: 'ARTICLE_MEDIA',
	name: 'Media',
	allowedSections: ['article', 'main'],
	disallowedChildren: ['*'],
	category: 'Article',
	props: [{
		name: 'mobileLayout',
		inputType: 'select',
		label: 'Layout on mobile',
		default: 'Slider',
		values: [{
			label: 'Zoom on hover',
			value: 'Zoom'
		}, {
			label: 'Slider',
			value: 'Slider'
		}, {
			label: 'Slider with zoom on hover',
			value: 'SliderZoom'
		}]
	}, {
		name: 'tabletLayout',
		inputType: 'select',
		label: 'Layout on tablet',
		default: 'Slider',
		values: [{
			label: 'Zoom on hover',
			value: 'Zoom'
		}, {
			label: 'Slider',
			value: 'Slider'
		}, {
			label: 'Slider with zoom on hover',
			value: 'SliderZoom'
		}]
	}, {
		name: 'desktopLayout',
		inputType: 'select',
		label: 'Layout on desktop',
		default: 'Slider',
		values: [{
			label: 'Zoom on hover',
			value: 'Zoom'
		}, {
			label: 'Zoom on scroll and click',
			value: 'TwoStepZoom'
		}, {
			label: 'Slider',
			value: 'Slider'
		}, {
			label: 'Slider with zoom on hover',
			value: 'SliderZoom'
		}, {
			label: 'Slider with zoom on scroll and click',
			value: 'TwoStepSliderZoom'
		}]
	}].filter(Boolean),
	hiddenProps: [{
		label: 'Slider layout settings',
		props: [{
			name: 'sliderAutoplay',
			inputType: 'checkbox',
			label: 'Autoplay',
			default: false
		}, {
			name: 'sliderLoop',
			inputType: 'checkbox',
			label: 'Loop',
			default: true
		}, {
			name: 'sliderSpeed',
			inputType: 'text',
			label: 'Animation speed',
			default: '300'
		}, {
			name: 'sliderDuration',
			inputType: 'text',
			label: 'Animation duration',
			default: '3000'
		}, {
			name: 'timing',
			inputType: 'select',
			label: 'Transition',
			default: 'ease',
			values: [{
				label: 'Linear',
				value: 'linear'
			}, {
				label: 'Ease',
				value: 'ease'
			}, {
				label: 'Ease-in',
				value: 'ease-in'
			}, {
				label: 'Ease-out',
				value: 'ease-out'
			}, {
				label: 'Ease-in-out',
				value: 'ease-in-out'
			}]
		}, {
			name: 'sliderArrows',
			inputType: 'checkbox',
			label: 'Arrows',
			default: false
		}, {
			name: 'sliderArrowsType',
			inputType: 'select',
			label: 'Choose arrow type',
			default: 'none',
			values: [{
				label: 'Native',
				value: 'none'
			}, {
				label: 'Icon',
				value: 'icon'
			}, {
				label: 'Image',
				value: 'image'
			}]
		},
			...conditionallyAddConfig(node, 'icon', iconConfig),
			...conditionallyAddConfig(node, 'image', imageConfig),
		{
			name: 'sliderPagination',
			inputType: 'checkbox',
			label: 'Pagination',
			default: true
		}, {
			name: 'sliderPaginationType',
			inputType: 'select',
			label: 'Choose pagination type',
			default: 'bullets',
			values: [{
				label: 'Bullets',
				value: 'bullets'
			}, {
				label: 'Fraction',
				value: 'fraction'
			}]
		}]
	}, {
		label: 'Zoom layout settings',
		props: [{
			name: 'zoomDelay',
			inputType: 'number',
			label: 'Delay before zooming',
			default: '500'
		}, {
			name: 'zoomPopup',
			inputType: 'checkbox',
			label: 'Popup on click',
			default: true
		}, {
			name: 'zoomThumbnails',
			inputType: 'checkbox',
			label: 'Show thumbnails',
			default: true
		}]
	}, {
		label: 'Badge settings',
		props: [{
			name: 'showSaleOrNew',
			inputType: 'checkbox',
			label: 'Show sale or new icon',
			default: false
		}, {
			name: 'showCampaigns',
			inputType: 'checkbox',
			label: 'Show campaign icon',
			default: true
		}, {
			name: 'campaignPopup',
			inputType: 'checkbox',
			label: 'Popup on campaign click',
			default: false
		}, {
			name: 'campaignHeader',
			inputType: 'text',
			label: 'Campaign popup header',
			default: ''
		}]
	}, {
		label: 'Advanced settings',
		props: [{
			name: 'isSizeMatchRequired',
			inputType: 'checkbox',
			label: 'Show images for selected size only',
			default: ''
		}, {
			name: 'class',
			inputType: 'text',
			label: 'CSS-class',
			default: ''
		}]
	}]
});
